<div class="flex flex-col items-center justify-center gap-2 text-center text-white px-4 py-3">
  <p class="text-[14px] font-bold leading-[1.3]">{{ 'deposit_address_missing.title' | translate }}</p>
  <p class="text-[12px] leading-[1.4]">{{ 'deposit_address_missing.text' | translate }}</p>
  @if (supportUrl(); as url) {
    <a [href]="url" target="_blank" rel="noopener noreferrer"
       class="text-[12px] font-bold underline text-[#FFD900] hover:opacity-80">
      {{ 'deposit_address_missing.link' | translate }}
    </a>
  }
</div>
